<template>
    <toolbar-option v-if="isVisible" type="stacked">
        <template v-if="isTypeVisible" slot="secondary">
            <dropdown
                :options="iconTypeOptions"
                :value="iconType"
                native
                @input="onTypeInput"
            />
        </template>

        <template slot="primary">
            <dropdown
                :value="selectedIcon"
                :options="iconOptions"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const ICON_ATTR_NAME = 'dropdown-icon';
const ICON_DISPLAY_ATTR_NAME = 'dropdown-icon-display';
const DEFAULT_VALUE = 'toggle';

export default {
    name: 'control-nav-dropdown-icon',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Icon',
            displayValue: DEFAULT_VALUE,

            iconType: 'collapsed',
            iconCollapsed: 'chevron-down',
            iconExpanded: 'chevron-up',
            isVisible: true,
            isTypeVisible: true,

            iconOptions: [
                { text: 'Chevron Up', value: 'chevron-up' },
                { text: 'Chevron Down', value: 'chevron-down' },
                { text: 'Chevron Circle Up', value: 'chevron-circle-up' },
                { text: 'Chevron Circle Down', value: 'chevron-circle-down' },
                { text: 'Plus', value: 'plus' },
                { text: 'Minus', value: 'minus' },
                { text: 'Plus Circle', value: 'plus-circle' },
                { text: 'Minus Circle', value: 'minus-circle' },
                { text: 'Home', value: 'home' },
                { text: 'User', value: 'user' },
                { text: 'User Circle', value: 'user-circle' },
            ],

            iconTypeOptions: [
                { text: 'Collapsed', value: 'collapsed' },
                { text: 'Expanded', value: 'expanded' },
            ],
        };
    },

    computed: {
        selectedIcon() {
            return this.iconType === 'collapsed' ? this.iconCollapsed : this.iconExpanded;
        },
    },

    watch: {
        changedOption({ option, value }) {
            if (option === 'nav-dropdown-icon-display') {
                this.isVisible = value !== 'hide';
                this.isTypeVisible = value === 'toggle';
            }
        },
    },

    methods: {
        onInput(icon) {
            if (this.iconType === 'collapsed') {
                this.iconCollapsed = icon;
            } else {
                this.iconExpanded = icon;
            }

            const iconData = {
                collapsed: this.iconCollapsed,
                expanded: this.iconExpanded,
            };

            this.selectedElements[0].setElementData(ICON_ATTR_NAME, iconData);
            this.onOptionChange(iconData);
        },

        onTypeInput(type) {
            this.iconType = type;
        },

        onSelectedElement() {
            const iconData = this.selectedElements[0].getElementData(ICON_ATTR_NAME);
            const iconDisplayData = this.selectedElements[0].getElementData(ICON_DISPLAY_ATTR_NAME);

            if (iconData) {
                this.iconCollapsed = iconData.collapsed;
                this.iconExpanded = iconData.expanded;
            } else {
                this.selectedElements[0].setElementData(ICON_ATTR_NAME, {
                    collapsed: 'chevron-down',
                    expanded: 'chevron-up',
                }, {
                    triggerChangeDetection: false,
                });
            }

            this.isVisble = !iconDisplayData || iconDisplayData !== 'hide';
            this.isTypeVisible = !iconDisplayData || iconDisplayData === 'toggle';
        },
    },
};
</script>
